import { Box, Heading, Text } from '@zillow/constellation-10';
import { Col } from '@zg-rentals/zrs-comet';

export interface InsightBoxProps {
  value: number;
  metric: string;
  formatter?: (value: number) => string;
}

const defaultFormatter = (value: number) => {
  return Math.round(value).toLocaleString();
};

export const InsightBox = ({ value, metric, formatter = defaultFormatter }: InsightBoxProps) => {
  if (value <= 0) {
    return null;
  }
  return (
    <Col xl={3} lg={6} md={6} sm={12} xs={12}>
      <Box
        css={{
          border: '1px solid',
          borderColor: 'gray.300',
          borderRadius: 'sm',
          height: 'calc(100% - 16px)',
          marginBottom: 'md',
          padding: 'md',
        }}
      >
        <Text>{metric}</Text>
        <Box css={{ marginBlock: 'xs' }}>
          <Heading level={3}>{formatter(value)}</Heading>
        </Box>
      </Box>
    </Col>
  );
};
